import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { get } from 'lodash';
import { Title } from 'web-ui-components/lib/atoms/text';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { DataTable } from 'web-ui-components/lib/molecules/tables';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import UnSavedWarningModal from '../../../sharedComponents/UnSavedWarningModal/UnSavedWarningModal';
import importPayeesContent, { contentPropTypes } from './index.content';
import { goBackPage, setBackPage } from '../../../states/page/actions';
import { submitImportPayeesRequest } from '../../states/action';
import { getPage } from '../../../states/page/selectors';
import { addNotification, clearNotification } from '../../../../src/states/notifications/actions';
import { getAllNotifications } from '../../../../src/states/notifications/selectors';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import { getAccountsForAddPayee } from '../../../states/accounts/selectors';
import { accountsForAddPayeePropTypes } from '../../../payees/states/addPayee/propTypes';
import { getFormattedData } from '../../../utils/benImportUtils';
import AttentionTile from '../../../sharedComponents/AttentionTile';
import PageNavigation from '../../../sharedComponents/PageNavigation/PageNavigation';
import { EnhancedBatchProgressTakeover } from '../../../sharedComponents/BatchProgressTakeover/BatchProgressTakeover';
import { getBrandId } from '../../../states/envConfig/selectors';

const mapState = (state) => ({
	currentPage: getPage(state),
	notification: getAllNotifications(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	accountsForAddPayee: getAccountsForAddPayee(state),
	brandId: getBrandId(state),
});

const mapDispatch = (dispatch) => ({
	goBackPage: () => dispatch(goBackPage()),
	setBackPage: (currentPage) => dispatch(setBackPage(currentPage)),
	clearNotification: (id) => dispatch(clearNotification(id)),
	addNotification: (a, b) => dispatch(addNotification(a, b)),
	submitImportPayeesRequest: (details) => dispatch(submitImportPayeesRequest(details)),
});

export class ImportPayees extends Component {
	constructor(props) {
		super(props);
		this.state = {
			enableContinue: false,
			isModalOpen: false,
		};
		this.handleConfirmImportPayees = this.handleConfirmImportPayees.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleModalBack = this.handleModalBack.bind(this);
	}
	componentDidMount() {
		const {
			content: { fileUploadUnfinishedContent },
			handleFileUploadInReview,
		} = this.props;
		handleFileUploadInReview(true, fileUploadUnfinishedContent);
	}

	componentWillUnmount() {
		const {
			content: { fileUploadUnfinishedContent },
			handleFileUploadInReview,
		} = this.props;
		handleFileUploadInReview(false, fileUploadUnfinishedContent);
	}
	handleModalBack() {
		const { notification = [], clearNotification, goBackPage } = this.props;
		const notificationId = get(notification, '[0].id', 0);
		if (notificationId) clearNotification(notificationId);
		this.setState({
			isModalOpen: false,
		});
		goBackPage();
	}
	handleConfirmImportPayees() {
		const {
			goBackPage,
			addNotification,
			content: { successMessage, invalidBenImport },
			submitImportPayeesRequest,
			importedPayeesList,
			accountsForAddPayee,
		} = this.props;
		const details = {
			importedPayeesList,
			successMessage,
			invalidBenImport,
			addNotification,
			goBackPage,
			accountsForAddPayee,
		};
		submitImportPayeesRequest(details);
	}
	handleCancel() {
		this.setState({
			isModalOpen: true,
		});
	}
	render() {
		const {
			content: { header, subHeader1, subHeader2, tableHeader, continueButtonText, footer },
			hasApiCallInProgress,
			importedPayeesList,
			brandId,
		} = this.props;
		const { isModalOpen, enableContinue } = this.state;

		return (
			<ServicingSection>
				<BackButton onClick={this.handleCancel} disabled={hasApiCallInProgress} />
				<Title size="h1">{header}</Title>
				<p>{subHeader1}</p>
				<p>{subHeader2}</p>
				<DataTable columns={tableHeader} data={getFormattedData(importedPayeesList)} keyPath={['id']} isBasic />
				<p>{footer}</p>
				<AttentionTile
					id="fraudAwareness"
					useOriginalCheckbox
					multiplePayees
					handleChange={() => this.setState({ enableContinue: !enableContinue })}
					isChecked={enableContinue}
					brandId={brandId}
				/>
				<EnhancedBatchProgressTakeover contentKey="checkPayees" />
				<PageNavigation
					showLoading={hasApiCallInProgress}
					handleContinue={this.handleConfirmImportPayees}
					showContinue
					showBack
					enableBack
					continueButtonText={continueButtonText}
					secondaryButtonText="Cancel"
					handleBack={this.handleCancel}
					enableContinue={enableContinue}
				/>
				{isModalOpen && (
					<UnSavedWarningModal
						handleClose={() => {
							this.setState({ isModalOpen: false });
						}}
						isModalOpen
						handleBack={this.handleModalBack}
						contentKey="importPayeesContent"
					/>
				)}
			</ServicingSection>
		);
	}
}

ImportPayees.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	goBackPage: PropTypes.func.isRequired,
	clearNotification: PropTypes.func.isRequired,
	addNotification: PropTypes.func.isRequired,
	submitImportPayeesRequest: PropTypes.func.isRequired,
	notification: PropTypes.arrayOf(PropTypes.string.isRequired),
	hasApiCallInProgress: PropTypes.bool.isRequired,
	importedPayeesList: PropTypes.arrayOf(PropTypes.object.isRequired),
	accountsForAddPayee: PropTypes.arrayOf(PropTypes.shape(accountsForAddPayeePropTypes)).isRequired,
	handleFileUploadInReview: PropTypes.func.isRequired,
	brandId: PropTypes.string.isRequired,
};

export const connectWrapper = compose(
	connect(mapState, mapDispatch),
	withContent({ content: importPayeesContent }),
	withScrollTop
)(ImportPayees);
